import { Button, Divider, Form, Space, Tabs } from 'antd';
import { setCookie, setStorage } from '@lhb/cache';
import { LoginParams, LoginResult } from './ts-config';
import styles from './index.module.less';
import VerificationCodeForm from './VerificationCodeForm';
import PasswordAccountForm from './passwordAccountForm';
import ChangePassword from './ChangePassword';
import { useVisible } from '@/hooks';
import { useState } from 'react';
import { MOBILE_REG } from '@lhb/regexp';
import { dispatchNavigate } from '@/common/document-event/dispatch';
import { loginStore } from '@/store';
import ChangeAccount from './ChangeAccount';

const { Item, useForm } = Form;

const { login } = loginStore;

const Login = () => {
  const [activeKey, setActiveKey] = useState<string | undefined>('0');
  const { visible, onShow, onHidden } = useVisible(false);
  const [form] = useForm();
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const onActiveKeyChange = (activeKey: string) => {
    setActiveKey(activeKey);
  };


  const onFinish = (values) => {
    const params: LoginParams = {
      ...values,
      tenant: 'linhuiba',
    };

    const isNeedChooseAccount: boolean = true;


    if (params.username?.includes('@')) {
      const arr = params.username.split('@');
      params.username = arr[0];
      params.tenant = arr[1];
    }

    // 如果是手机号入参为mobile
    if (MOBILE_REG.test(values.username)) {
      params.mobile = values.username;
      delete params.username;
      // isNeedChooseAccount = true;
    }

    setLoading(true);
    login(params).then((data: LoginResult) => {
      const { token } = data;

      if (token) {
        setCookie('loginToken', token);
        if (isNeedChooseAccount) { // 输入手机号时需要选择企业
          setShowAccountModal(true);
        } else {
          // 用户名进行登录不需要选择手机号
          dispatchNavigate('/');
          setCookie('newPmsToken', token);
          setStorage('newPmsToken', token);
          setStorage('getTokenApi', '/mirage/login');
        }
      }
    }).finally(() => setLoading(false));
  };

  // 提交form表单
  const handleSubmit = async () => {
    let values = await form.validateFields();
    const { username } = values;
    if (MOBILE_REG.test(username)) {
      values = {
        ...values,
        mobile: username
      };
    }
    onFinish(values);
  };

  const onSubmit = (success: boolean) => {
    if (success) {
      window.microMessage.success('修改成功');
      onHidden();
    }
  };

  const onCancelSubmit = () => {
    onHidden();
  };


  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.mainImg}></div>
            <div className={styles.rightBottomImg}></div>
          </div>
          <div className={styles.rightWrapper}>
            <div className={styles.right}>
              <p className={styles.title}>欢迎登录</p>
              {/* <p className={styles.subTitle}>Resource Services</p> */}
              <Tabs
                activeKey={activeKey}
                onChange={onActiveKeyChange}
                items={[{ label: '验证码登录', key: '0' }, { label: '密码登录', key: '1' }]}>
              </Tabs>
              <div className={styles.rightTopImg}></div>
              <Form
                className={styles.loginForm}
                form={form}
              >
                {/* <VerificationCodeForm/> */}
                { activeKey === '1' ? <VerificationCodeForm /> : <PasswordAccountForm form={form}/> }
                <Space
                  className={styles.spaceWrapper}
                  split={<Divider type='vertical' />}>
                  <Button type='link' onClick={onShow}>忘记密码?</Button>
                  {/* <Button >注册账号</Button> */}
                </Space>
                <Item>
                  <Button
                    block
                    size='large'
                    type='primary'
                    loading={loading}
                    onClick={handleSubmit}
                  >
                    {loading ? '正在登录中' : '登录'}
                  </Button>
                </Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <ChangePassword
        visible={visible}
        onSubmit={onSubmit}
        onCancelSubmit={onCancelSubmit}
      />
      <ChangeAccount showAccountModal={showAccountModal} showChangeAccount={setShowAccountModal} />
    </>
  );
};

export default Login;
